export default __webpack_public_path__ + "static/media/imagen.476a027c.png";